import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, 
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem} from '../../../Redux/actions/crudActions'
import {errorParser} from '../../../utils/helpers'
import InputSelect from '../InputSelect'
import CreateForm from '../CreateForm'

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,onModalClose,blueprint,modalMode,headername,token,apiurl,hideAdd}) => { 
    
    const dispatch = useDispatch()    

    const { orders,toPackOrders,toShipOrders,shippedOrders,cancelledOrders,googleSheetsInventoryData,gsheetLoading,gSheetsUpdateCount } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )

    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [currentOrder, setCurrentOrder] = useState(''); 
    const [loading, setLoading] = useState(false)
    const [item, setItem] = useState(false)
    const [modalCurrentMode, setModalCurrentMode] = useState('add')
    const [formSubmitClick, setFormSubmitClick] = useState(false)
    const [modalWidth, setmodalWidth] = useState('80%')



    

    useEffect(() => {
      setModalCurrentMode(modalMode)

    },[modalMode]);



    useEffect(() => {
      if(blueprint){
        blueprint.map(blue=>{
          if(blue.type=='email-editor' ||  blue.type=='site-editor'){
            setmodalWidth('94%')
          }
        })
      }

      if(currentItem && modalMode=='edit'){
        console.log(currentItem)
        if(currentItem.id !== undefined){
          setIsModalVisible(true)
          setItem(currentItem)
        }
      }
     
    },[currentItem]);





    const saveChanges = (form) =>{
 
        console.log('form data',form)
        setLoading(true)
        if(form.errorFields){
          form.errorFields.map(er=>{
            er.errors.map(err=>{
              message.error(err)
            })
          })
          setLoading(false)        
        }else if(modalCurrentMode == 'edit' && !item.id ){
          message.error("can't find identifier")
          setLoading(false)
        }else{
          console.log('3')
          console.log('form',form)
          var formData ={
            ...form,
          }
          Object.keys(formData).forEach(key => formData[key] === undefined ? delete formData[key] : {});
      
          var form_data = {};
          
          Object.entries(formData).map(([key, value]) =>{ 
            console.log(key,value, Array.isArray(value))
            var newval = value
            
            if(Array.isArray(value)){
              if(newval.length == 0){
                newval = []
                console.log(newval)
              }
          
            }
            form_data[key] = newval;
          })

          console.log('formData',form_data)
          if( modalCurrentMode == 'add'){
            var created_at = moment().format('YYYY-MM-DD HH:mm:ss')
            form_data['created_at'] = created_at;
            dispatch(addItem(form_data, apiurl))
            .then(res=>{          
              message.success('Item Created')
              closeModal('reset')
              setLoading(false)
            })
            .catch((err)=>{    
              var formattedErr = errorParser(err.response)       
              if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
                formattedErr.map(er=>{message.error(er)})
              }else{
                message.error(formattedErr)              
              }
              setLoading(false)
            })
          }else{
            var newform ={
              ...currentItem,
              ...form_data
            }
            dispatch(editItem(newform,apiurl,item.id))
            .then(res=>{          
              message.success('changes saved!')
              closeModal('reset')
              setLoading(false)
            })
            .catch((err)=>{    
              var formattedErr = errorParser(err.response)       
              if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
                formattedErr.map(er=>{message.error(er)})
              }else{
                message.error(formattedErr)              
              }
              setLoading(false)
            })
          }
        }  
    }

    const deleteCurrent =()=>{
      setLoading(true)
      if(!item.id ){
        message.error("can't find identifier")
        setLoading(false)
      }else{
        dispatch(deleteItem(apiurl, item.id) )
        .then(res=>{          
          message.success('item deleted!')
          closeModal('reset')
          setLoading(false)
        })
        .catch((err)=>{    
          var formattedErr = errorParser(err.response)       
          if(typeof formattedErr == 'object' ||  typeof formattedErr == 'array'){
            formattedErr.map(er=>{message.error(er)})
          }else{
            message.error(formattedErr)              
          }
          setLoading(false)
        })
      }
    }

    const disabledDate =(current) =>{
      return  current < moment().endOf('day');
    }

    
    const footer = () =>{
      return(
        <div>
           { modalCurrentMode == 'edit' ?
           <Popconfirm
              title="Are you sure to delete this?"
              onConfirm={()=>{deleteCurrent()}}        
              okText="Yes"
              cancelText="No"
            >  
              <Button type="danger" loading={loading}  >
                Delete
              </Button>  
            </Popconfirm>
            :null}
        
          <Button type="primary" loading={loading} onClick={()=>{setFormSubmitClick(true)}} >
           {modalCurrentMode == 'add' ? 'Create': 'Save Changes'}
          </Button>      
          
        </div>
      )
     
    }
    

    const closeModal = (action) =>{
      if(!loading){
        if(modalCurrentMode == 'edit'){
          setItem(null)
        }
        setIsModalVisible(false); 
        onModalClose(action);
 
      }
    }

    return(       
      <>
      {hideAdd? null: 
      <div className={"addeditbutton"}>
        <Button  type="primary" shape="round" icon={<PlusOutlined />} onClick={()=>{setModalCurrentMode('add');setIsModalVisible(true); setLoading(false)}} >{`Add ${headername}`}</Button>  
        
      </div>
      }
      {isModalVisible?  
        <Modal title={modalCurrentMode == 'add' ? `Add ${headername}` : `Edit ${headername}`}  visible={isModalVisible} footer={footer()} onCancel={()=>{closeModal()}} width={modalWidth}>
          <div className="orderaddedit-content">
            <CreateForm  currentItem={item}  blueprint={blueprint} token={token} saveForm={(e)=>{saveChanges(e); setFormSubmitClick(false)}} FormSubmitClick={formSubmitClick} /> 
          </div>
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  